<template>
  <div>
    <main class="news">
      <main-header fixed />
      <filter-country
        class="news__filter"
        v-show="!fetching"
        @onSelectFilter="filterNews($event)"
      />
      <sui-loader v-show="fetching" class="general-loader" size="large" active centered inline />
      <h3
        v-show="(errorMessage && !fetching) || (items.length === 0 && !fetching)"
        class="news--no-results"
      >
        {{ errorMessage || $t("generals.newsfounded") }}
      </h3>
      <div
        v-show="!fetching"
        class="news__cell"
        v-for="(article, index) in news"
        :key="`${article.title}${index}`"
      >
        <news-item
          :class="[
            'news__cell__item',
            {
              'news__cell__item--right-padding': article.indexTemplate === 2,
              'news__cell__item--left-padding': article.indexTemplate === 3,
              'news__cell__item--right': article.indexTemplate === 4,
            },
          ]"
          :title="article.title"
          :description="article.short_content"
          :image="article.image"
          :link="article.slug"
        />
      </div>

      <paginate
        v-model="filters.page"
        v-show="pagination.total > 14 && !fetching && !errorMessage"
        :page-count="pagination.lastPage"
        :page-range="3"
        :margin-pages="2"
        :click-handler="paginate"
        :prev-text="'<'"
        :next-text="'>'"
        :container-class="'pagination'"
        :page-class="'page-item'"
      >
      </paginate>
      <scroll-to />
    </main>

    <main-footer ref="footer" style="bottom: 0;" />
  </div>
</template>

<script>
import NewsItem from "@/components/news/news-item";

let hasLastPosition;
export default {
  name: "news",
  components: {
    "news-item": NewsItem,
  },

  data() {
    return {
      indexTemplate: 0,
      items: [],
      fetching: true,
      lastPosition: null,
      pagination: {
        total: 0,
        perPage: 30,
        lastPage: 0,
      },
      filters: {
        page: 1,
      },
      errorMessage: null,
    };
  },

  computed: {
    news() {
      if (this.items.length > 0) {
        /* eslint-disable vue/no-side-effects-in-computed-properties */
        return this.items.map((article) => {
          if (this.indexTemplate >= 4) {
            this.indexTemplate = 0;
          }

          this.indexTemplate += 1;
          return {
            ...article,
            indexTemplate: this.indexTemplate,
          };
        });
      }
      return [];
    },
  },

  mounted() {
    this.getNews(this.$store.state.ui.language);

    this.$hub.$on("repeatRequests", (language) => {
      this.getNews(language, this.filters);
    });
  },

  destroyed() {
    this.$hub.$off("repeatRquests");
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === "SingleNews") {
      hasLastPosition = true;
    }
    next();
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setWindowPosition", $(window).scrollTop());
    next();
  },

  methods: {
    getNews(language = "en", filters) {
      this.fetching = true;
      this.errorMessage = null;
      this.pagination.total = 0;
      this.pagination.lastPage = 0;

      this.$news
        .get(language, filters)
        .then((resolve) => {
          this.indexTemplate = 0;
          this.items = resolve.data.items;
          this.pagination.lastPage = resolve.paginate.last || 0;
          this.pagination.total = resolve.paginate.total || 0;
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          this.errorMessage = this.$t("generals.error");
          this.items = [];
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
          if (hasLastPosition) {
            setTimeout(() => {
              $("body, html").scrollTop(this.$store.state.ui.lastWindowPosition);
            }, 80);
          }
        });
    },

    paginate(page) {
      this.filters.page = page;
      this.getNews(this.$store.state.ui.language, this.filters);

      $("body, html").scrollTop(0);
    },

    filterNews(filter) {
      this.filters.regional = filter.id;
      this.filters.page = 1;

      this.getNews(this.$store.state.ui.language, this.filters);

      $("body, html").scrollTop(0);
    },
  },
};
</script>

<style lang="scss">
.news {
  background: white;
  height: 100%;
  padding-top: 60px;
  min-height: 100vh;
  overflow: hidden;
  z-index: 2;
  position: relative;
  margin-bottom: 300px;

  &--no-results {
    color: black;
    width: 100%;
    text-align: center;
    font-weight: 300;
    font-size: 25px;
    letter-spacing: 1px;
    max-width: 90%;
    margin: 0 auto;
  }

  &--loader {
    top: 80px !important;
  }

  &__filter {
    margin: 170px 0 120px;
  }

  &__cell {
    display: flex;
    margin-bottom: 150px;

    &__item {
      padding: 0 30px !important;
      &--right-padding {
        justify-content: flex-end;
        margin-right: 7vw;
      }

      &--left-padding {
        margin-left: 7vw;
      }

      &--right {
        justify-content: flex-end;
      }
    }
  }
}

@media (max-width: 1000px) {
  .news {
    &__filter {
      margin: 100px 0 70px;
    }

    &__cell {
      margin-bottom: 60px;

      &__item {
        padding: 0 10px !important;
        &--right-padding {
          margin: 0;
          justify-content: start;
        }

        &--left-padding {
          margin: 0;
          justify-content: start;
        }

        &--right {
          margin: 0;
          justify-content: start;
        }
      }
    }
  }
}
</style>
